import React from 'react';
import { useNavigate } from 'react-router-dom';

const StepperButtons = ({ 
  onBack, 
  onNext, 
  nextPath, 
  backPath, 
  nextLabel = 'Continue to Sessions', 
  backLabel = 'Back',
  nextDisabled = false,
  showBack = true,
  showNext = true,
  loading = false,
  sticky = true,
  wrapperClassName = '',
  containerClassName = '',
  centerContent = null
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  const handleNext = () => {
    if (onNext) {
      onNext();
    } else if (nextPath) {
      navigate(nextPath);
    }
  };

  return (
    <div
      className={`bg-white border-t border-gray-200 shadow-lg ${
        sticky ? 'fixed bottom-0 left-0 right-0 z-40' : ''
      } ${wrapperClassName}`}
    >
      <div className={`container mx-auto px-4 py-4 ${containerClassName}`}>
        <div className="flex justify-between items-center gap-4">
          {showBack ? (
            <button
              onClick={handleBack}
              disabled={loading}
              className="px-6 py-2.5 rounded-full font-semibold text-sm bg-gray-200 hover:bg-gray-300 text-gray-700 transition-all duration-300 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <i className="fas fa-arrow-left mr-2"></i>
              {backLabel}
            </button>
          ) : (
            <div></div>
          )}

          {centerContent ? (
            <div className="flex-1 flex justify-center">{centerContent}</div>
          ) : (
            <div className="flex-1" />
          )}

          {showNext && (
            <button
              onClick={handleNext}
              disabled={nextDisabled || loading}
              className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 shadow-lg hover:shadow-xl ${
                nextDisabled || loading
                  ? 'bg-gray-400 cursor-not-allowed text-white'
                  : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white'
              }`}
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin mr-2"></i>
                  Loading...
                </>
              ) : (
                <>
                  {nextLabel}
                  <i className="fas fa-arrow-right ml-2"></i>
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StepperButtons;
